/**
 * Typed API client generated from drf-spectacular's OpenAPI schema (`src/api/schema.ts`,
 * regenerated by `make openapi`).
 *
 * `credentials: 'same-origin'` carries the session cookie (NFR-5) — authentication is a
 * Django session, not a token. `X-CSRFToken` is attached to every unsafe request by reading
 * the `csrftoken` cookie Django sets: DRF's `SessionAuthentication` only enforces CSRF once a
 * session exists, and `login`/`register` call `get_token()` server-side so the cookie is
 * already there by the time anything unsafe is sent.
 */
import createClient from 'openapi-fetch'

import type { paths } from './schema'

function readCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : null
}

export const api = createClient<paths>({
  baseUrl: '/',
  credentials: 'same-origin',
})

api.use({
  onRequest({ request }) {
    if (!['GET', 'HEAD', 'OPTIONS'].includes(request.method)) {
      const token = readCookie('csrftoken')
      if (token) {
        request.headers.set('X-CSRFToken', token)
      }
    }
    return request
  },
})

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly body?: unknown,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}
